import { useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "votos2026Aceitos";

const steps = [
  {
    question: (
      <>
        Poderia, por obséquio, estar
        <br />
        renovando seus votos comigo
        <br />
        por mais 1 ano?
      </>
    ),
    button: "Sim, eu quero",
  },
  { question: "Quer mesmo?",                          button: "Sim, eu quero" },
  { question: "Tem certeza?",                         button: "Sim, eu quero" },
  { question: "Absoluta?",                            button: "Sim, eu quero" },
];

function Final() {
  const [step, setStep] = useState(() =>
    localStorage.getItem(STORAGE_KEY) === "true" ? steps.length : 0
  );

  const advance = () => {
    setStep((s) => {
      const next = s + 1;
      if (next >= steps.length) {
        localStorage.setItem(STORAGE_KEY, "true");
      }
      return next;
    });
  };

  const accepted = step >= steps.length;

  return (
    <>
      <div
        id="final-2026"
        className="d-flex align-items-center justify-content-center py-5"
      >
        <div className="container py-5 text-center">
          {!accepted ? (
            <>
              <h3>{steps[step].question}</h3>
              <br />
              <button className="final-btn" type="button" onClick={advance}>
                {steps[step].button}
              </button>
            </>
          ) : (
            <h2>
              Eu te amo muito, meu amor
              <br />
              Obrigado por existir
            </h2>
          )}
        </div>
      </div>
      {accepted && (
        <div
          id="final-links"
          className="d-flex align-items-center justify-content-center"
        >
          <Link to="/notes">bilhetinhos</Link>
          <a href="/2025">ano passado</a>
        </div>
      )}
    </>
  );
}

export default Final;
